export const colors = {
  darkBlue: "#1A1F2C", // Primary
  darkGreen: "#124A28", // Secondary
  lightGreen: "#D7FFE7",
  lightBlue: "#E3F3FF",
  lightGray: "#b3b1b1",
  darkGray: "#71717A",
  extraLightGray: "#FBFBFC",
  doubleExtraLightGray: "#efefef",
  white: "#fff",
  black: "#444444",
  // Aliases for consistency
  primary: "#1A1F2C",
  secondary: "#124A28",
  background: "#fff",
  text: {
    primary: "#444444",
    secondary: "#71717A",
  },
};
